query GetConnectNextSteps {
    connectNextSteps {
        nextSteps
        isComplete
    }
}
